import { render, staticRenderFns } from "./v3.vue?vue&type=template&id=db81a82a&scoped=true"
import script from "./v3.vue?vue&type=script&lang=js"
export * from "./v3.vue?vue&type=script&lang=js"
import style0 from "./v3.vue?vue&type=style&index=0&id=db81a82a&prod&lang=scss&scoped=true"
import style1 from "./v3.vue?vue&type=style&index=1&id=db81a82a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_2wi5n7v5trihbigbnnizsbscmu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db81a82a",
  null
  
)

export default component.exports